import classNames from 'classnames';
import { bool, node, string } from 'prop-types';

import { AnimatedBottomPopup } from '~/components/PopupsWithTransition';

import style from './BottomPopupWithTransition.module.scss';
// todo: merge with BottomSheetDialog

export default function BottomPopupWithTransition({
  banner,
  bannerClassName,
  body,
  closeButtonEnabled,
  closeButtonClassName,
  containerClassName,
  className,
  footer,
  ...props
}) {
  return (
    <>
      <AnimatedBottomPopup
        className={classNames(style.bottomPopup, className)}
        buttonClassName={classNames(
          closeButtonEnabled ? style.closeButton : style.hidden,
          closeButtonClassName,
        )}
        containerClassName={classNames(
          style.modalContainer,
          containerClassName,
        )}
        {...props}
      >
        {banner && (
          <span className={classNames(style.banner, bannerClassName)}>
            {banner}
          </span>
        )}
        {body}
        {footer}
      </AnimatedBottomPopup>
    </>
  );
}

BottomPopupWithTransition.propTypes = {
  className: string,
  banner: string,
  bannerClassName: string,
  body: node,
  closeButtonClassName: string,
  closeButtonEnabled: bool,
  containerClassName: string,
  footer: node,
};
